module.exports = __webpack_public_path__ + "static/media/error-icon.19ce379a.svg";